<template>
  <div class="order-table">

    <transition-group name="fade">
      <div
        class="stack-divider product-row"
        v-for="(child, index) in names"
        :key="child.id"
        :index="index"
      >
        <!-- <img
          src="http://www.toucanbox.localhost/img/boxes/petite.svg"
          alt="toucanbox box"> -->
        <img
          src="https://toucanwww.herokuapp.com/img/boxes/petite.svg"
          alt="toucanbox box">

        <div class="product-row-price">
          <p><strong :style="{ 'text-decoration': discount ? 'line-through' : 'none' }">£4.95</strong></p>
          <p>£1.00</p>
        </div>
        <div class="product-row-info">
          <p class="product-type">toucanBox</p>
          <p>Fortnightly delivery</p>
          <transition name="fade">
            <p
              class="product-personalisation"
              v-if="child.name !== ''"
            ><strong>for {{ child.name }}</strong></p>
          </transition>
        </div>
      </div>

      <div
        :key="'last'"
        class="stack-divider stack-end">
        <div class="pricing-table">
          <h3>Order Total</h3>
          <div class="free">
            <h4
              v-if="discount"
            >This delivery</h4>
            <div class="price-breakdown">
              <div class="subscriptions">
                <div>toucanBox ({{ products }})</div>
                <div
                  v-if="discount"
                ><strong>FREE</strong></div>
                <div
                  v-else
                >£{{ (4.95 * products).toFixed(2) }}</div>
              </div>
              <div class="delivery">
                <div>Delivery ({{ products }})</div> <div>£{{ products }}.00</div>
              </div>
              <div class="price-total">
                <div>Total</div>
                <div
                  v-if="discount"
                >£{{ products }}.00</div>
                <div
                  v-else
                >£{{ (4.95 * products + products).toFixed(2) }}</div>
              </div>
            </div>
          </div>
          <div
            class="usual-price"
            v-if="discount"
          >
            <h4>Future deliveries</h4>
            <div class="price-breakdown">
              <div class="subscriptions">
                <div>toucanBox ({{ products }})</div> <div>£{{ (4.95 * products).toFixed(2) }}</div>
              </div>
              <div class="delivery">
                <div>Delivery ({{ products }})</div> <div>£{{ products }}.00</div>
              </div>
              <div class="price-total">
                <div>Total</div> <div>£{{ (4.95 * products + products).toFixed(2) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  props: {
    products: {
      type: Number,
      default: 1
    },
    names: {
      type: Array,
      default: function () { return [] }
    },
    discount: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/library/order-table.vue